<template>
	<v-container
		v-if="show"
		grid-list-xl
		my-2
	>
		<v-layout
			row
			justify-center
			ma-0
		>
			<v-flex
				xs12
				md8
				pa-0
				ma-0
			>
				<slot name="alert"/>
			</v-flex>
		</v-layout>
		<v-layout
			row
			wrap
			align-center
			justify-center
			ma-3
		>
			<v-flex
				pa-0
				xl8
			>
				<v-layout
					row
					wrap
					justify-center
				>
					<v-card
						width="100%"
						class="overflow-scroll"
					>
						<v-toolbar
							flat
							color="white"
						>
							<v-text-field
								v-model="search"
								append-icon="search"
								label="Search"
								single-line
								hide-details
							/>
						</v-toolbar>
						<v-data-table
							ref="table"
							:headers="headers"
							:items="publications"
							:search="search"
							:rows-per-page-items="[24,48,96]"
							:pagination.sync="pagination"
							rows-per-page-text="Items per page:"
						>
							<v-progress-linear
								slot="progress"
								indeterminate
								color="secondary"
							/>
							<template
								slot="items"
								slot-scope="props"
							>
								<td>{{ props.item.name }}</td>
								<td>{{ props.item.urlId }}</td>
								<td class="text-xs-right">{{ props.item.country }}</td>
								<td class="text-xs-right">
									{{ props.item.mozStats.domainAuthority | formatNumber }}
								</td>
								<td class="text-xs-right">{{ props.item.alexaStats.reachUsers | shortNumber }}</td>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			search: '',
			headers: [
				{ text: 'Name', value: 'name', sortable: true, width: '300px' },
				{ text: 'URL ID', value: 'urlId', sortable: true },
				{ text: 'Country', value: 'country', sortable: true, width: '1%' },
				{ text: 'Domain Authority', value: 'mozStats.domainAuthority', sortable: true, width: '1%' },
				{ text: 'Reach (users)', value: 'alexaStats.reachUsers', sortable: true, width: '1%' },
			],
			pagination: {
				page: 1,
			},
		};
	},
	created() {
		// Redirect to not found if user doesn't have permission to settings
		/** @todo Improve on global level, good for now */
		this.show = this.$store.get('isSkilled', 'report_publications');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	watch: {
		'pagination.page': {
			handler() {
				window.scrollTo(0, 0);
			},
		},
	},
	computed: {
		publications() {
			return this.$store.get('reportPublications');
		},
	},
};
</script>
